export var ProjectSignals;
(function (ProjectSignals) {
    ProjectSignals.StorageUpdated = Object.freeze({ type: "project-storage-updated" });
})(ProjectSignals || (ProjectSignals = {}));
